<template>
    <div class="flex-center">
        <v-btn small class="mr-2" depressed @click="createState=!createState">
            <v-icon color="success" left>add</v-icon>
            Thêm
        </v-btn>
        <v-btn v-show="selected.length" small color="error" class="mr-2" depressed @click="onRemove">
            <v-icon left>delete</v-icon>
            Delete
        </v-btn>
        <v-btn v-show="selected.length" small class="mr-2" depressed @click="mailDialogState=!mailDialogState">
            <v-icon left>email</v-icon>
            Email
        </v-btn>
        <v-btn v-show="selected.length" small class="mr-2" depressed @click="smsDialogState=!smsDialogState">
            <v-icon left>sms</v-icon>
            SMS
        </v-btn>
        <v-btn v-show="selected.length" small class="mr-2" depressed @click="disableContact">
            <v-icon left>lock</v-icon>
            Lock
        </v-btn>
        <v-btn v-show="this.selected.length" small class="mr-2" depressed @click="enableContact">
            <v-icon left>lock_open</v-icon>
            UnLock
        </v-btn>
        <send-email-dialog :state="mailDialogState" :data="selected"></send-email-dialog>
        <send-s-m-s-dialog :state="smsDialogState" :data="selected"></send-s-m-s-dialog>
        <new-contact-dialog :state="createState"/>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import SendEmailDialog from '@/modules/email/SendEmailDialog'
import SendSMSDialog from '@/modules/sms/SendSMSDialog'
import NewContactDialog from '@/modules/contact/NewContactDialog'

export default {
  components: {
    SendEmailDialog,
    SendSMSDialog,
    NewContactDialog
  },
  props: {
    disabled: Boolean,
    selected: { type: Array, default: () => [] }
  },
  data () {
    return {
      mailDialogState: false,
      smsDialogState: false,
      smsEditingState: false,
      createState: false,
      sending: null
    }
  },
  computed: {
    ...mapState('contact', ['contacts']),
    sendingName () {
      const { name } = this.contacts.find(contact => contact.phone === this.sending)
      return name
    }
  },
  methods: {
    ...mapActions('contact', [
      'removeContacts',
      'updateContacts'
    ]),
    ...mapActions('noti', [
      'sendEmails',
      'sendSMS'
    ]),
    disableContact () {
      this.updateContacts(this.selected.map(item => {
        return { ...item, status: 'block' }
      }))
    },
    enableContact () {
      this.updateContacts(this.selected.map(item => {
        return { ...item, status: 'active' }
      }))
    },
    onRemove () {
      this.$dialog.confirm({
        title: 'Xóa Contact',
        text: 'Bạn có muốn xóa những contacts này?',
        okText: 'Có',
        cancelText: 'Không',
        done: async () => {
          await this.removeContacts(this.selected)
          for (let i = this.selected.length - 1; i > -1; i--) {
            if (!this.contacts.includes(this.selected[i])) {
              this.selected.splice(i, 1)
            }
          }
        }
      })
    }

  }
}
</script>
